// extracted by mini-css-extract-plugin
export default {"AllPages-description":"AllPages-description1jb75YFRHhur","AllPages-fieldset":"AllPages-fieldset398R3FahmfGr"};